import React, { useState } from 'react'
import Button from '../../../../../components/Buttons/Button'
import EmptyData from '../../../../../components/EmptyData'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useQuery } from 'react-query';
import { api } from '../../../../../api/learningPath';
import { useNavigate, useParams } from 'react-router';
import Pagination from '../../../../../components/pagination/Pagination';
import Table from '../../../../../components/table/Table';
import Loader from '../../../../../components/loader/Loader';
import AssignSurveyModal from './components/AssignSurveyModal';
const ActionPlan = () => {

      const [perPage, setPerPage] = useState<number>(5);
      const [search, setSearch] = useState<string>("");
      const [currentPage, setCurrentPage] = useState<number>(1);
      const navigate = useNavigate()
      const orgId = JSON.parse(sessionStorage.getItem("user")!)?.org?.id;
      const {id} = useParams()
      const [openModal, setOpenModal] = useState<boolean>(false)
      const [activeActionPlanId, setActiveActionPlanId] = useState<string>("")
     
      const {
          data: actionPlans,
          isLoading,
        } = useQuery(
          ["action plans", orgId, search, perPage, currentPage],
          () => {
            return api.getCohortActionPlan({
              id: orgId,
              search,
              perPage,
              currentPage,
              cohortId: id
            });
          },
          {
            staleTime: 3000,  
            cacheTime: 3000,  
            select: (data) => data,
          }
        );

     let columns = React.useMemo( () => [
            {
              title: "ID",
              selector: null,
              key: "id",
              render: ({ index } : {index: number}) =>
                index +
                1 +
                ((actionPlans?.meta?.page || 1) - 1) * (actionPlans?.meta?.perPage || perPage ),
            },
            {
                title: "Name",
                selector: "name",
                key: "name",
                render: ({ item, row } : any) => {                      
                    return( 
                        <span className="">
                            {row?.plan?.name}
                      </span>
                    )
                },
              },
            {
              title: "Goal Percentage",
              selector: 'goalPercentage',
              key: 'goalPercentage',
              render: ({ item } : any) => {                      
                  return( 
                      <span>
                         {item}%
                      </span>
                  )
              },
            },
            {
              title: "Achievement Percentage",
              selector: 'achievementPercentage',
              key: 'achievementPercentage',
              render: ({ item }: any) => {                      
                  return( 
                      <span className="pl-3">
                        {item}%
                     </span>
                  )
              },
            },
            {
                title: "Status",
                selector: null,
                key: null,
                render: ({ row } : any) => {                      
                    return( 
                        <span className={
                            `${row?.plan?.status === 'in progress' ? 'block text-primary rounded-full w-[80px] text-center py-1 border border-primary'
                             : 'text-primary-green block w-[80px] text-center py-1 border border-primary-green rounded-full' 
                           }`}>
                           {row?.plan?.status}
                        </span>
                    )
                },
              },
            {
                title: "Number Of Goals",
                selector: "numberOfGoals",
                key: "numberOfGoals",
                render: ({ row } : any) => {                      
                  return <span>{row?.plan?.numberOfGoals}</span>
                }
              },
              {
                title: "Key Learning Per Goal",
                selector: "keyLearningPerGoal",
                key: "keyLearningPerGoal",
                render: ({ row } : any) => {                      
                  return <span>{row?.plan?.keyLearningPerGoal}</span>
                }
              },
              {
                title: "Timeline Unit",
                selector: "timelineUnit",
                key: "timelineUnit",
                render: ({ row } : any) => {                      
                  return <span>{row?.plan?.timelineUnit}</span>
                }
              },
            {
              title: "Start Date Time",
              selector: null,
              key: null,
              render: ({ row } : any) => {           
                return <span className="">
                    {`${ new Date(row?.plan?.startDateTime).toLocaleDateString('en-ng')}`}
                </span>;
              },
            },
            {
              title: "Completion Date",
              selector: null,
              key: null,
              render: ({ row } : any) => {           
                return <span className="">
                    {`${ new Date(row?.plan?.completeByDateTime).toLocaleDateString('en-ng')}`}
                </span>;
              },
            },
            {
              title: "Action",
              selector: null,
              key: null,
              render: ({row} : any) => {           
                return  <DropdownMenu.Root>
                            <DropdownMenu.Trigger asChild>
                            <button
                                className="text-sm bi bi-three-dots-vertical font-semibold" 
                                aria-label="Customise options" 
                            />
                                </DropdownMenu.Trigger>
                                <DropdownMenu.Portal>
                            <DropdownMenu.Content className="DropdownMenuContent" sideOffset={5}>
                            <DropdownMenu.Item
                                className="DropdownMenuItem text-left  hover:bg-gray-200 text-primary-blue"
                                onClick={ () => navigate(`/admin/cohort/action-plan-learners/${row?.plan?.id}/${id}`)  }
                            >
                                <i className='pr-1' /> Learners
                            </DropdownMenu.Item>
                            <DropdownMenu.Separator className="DropdownMenuSeparator" />
                            <DropdownMenu.Item
                                className="DropdownMenuItem text-left  hover:bg-gray-200 text-primary-blue"
                                onClick={ () => {
                                  setActiveActionPlanId(row?.plan?.id)
                                  setOpenModal(true)
                                } }
                            >
                                <i className='pr-1' /> Assign Survey
                            </DropdownMenu.Item>
                            <DropdownMenu.Separator className="DropdownMenuSeparator" />
                            </DropdownMenu.Content>
                        </DropdownMenu.Portal>
                    </DropdownMenu.Root>
              },
            },
          ],
          [1, 20, 20]
        );

    const tableProps = { isLoading, columns, data: actionPlans?.data }

  return (
    <div className='mt-5'>
      <AssignSurveyModal 
        open={openModal}
        setOpen={setOpenModal}
        activeActionPlanId={activeActionPlanId}
      />
        <header className='flex justify-between'>
            <h2>Action Plan Overview</h2>
            {
             //@ts-ignore
             <Button 
                renderAs='link' 
                to={'/admin/cohort/'}
                text={'Back'}
                width={'w-[130px]'}
                bgColor={'bg-customBlue'}
            />
            }
        </header> 
        <div className='bg-white pt-5 mt-3'>
            <header className='flex justify-between px-3 items-center'>
               <span className='text-sm'>Total Action Plan ({actionPlans?.meta?.total})</span>
               <div className='w-[300px]'>
                    <input
                        type="search"
                        className="input-style bg-primaryGray"
                        placeholder="&#128269; Search Action Plan...."
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setSearch(event.target.value);
                        }}
                    />
               </div>
            </header>
             {
                isLoading ? <Loader /> :
                actionPlans?.meta?.total ?
                   <Table {...tableProps} />
                :
                <EmptyData text={`There is no any action plan for this cohort`} />
             }
             <Pagination
              data={actionPlans?.meta}
              perPage={perPage}
              pageNo={currentPage}
              setPageNo={setCurrentPage}
              setPerPage={setPerPage}
            />
        </div>
    </div>
  )
}

export default ActionPlan